/* eslint-disable no-async-promise-executor */
/* eslint-disable prefer-promise-reject-errors */
// Handlers for app data store (App data store is for saving common basic data like side menu data)
import connector from '../connector';

// data format in this store is like this: {name: 'name', value: {object of data}}

// eslint-disable-next-line no-async-promise-executor
const add = (dataObject) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('appData', 'readwrite');
        const appDataStore = transaction.objectStore('appData');

        appDataStore.delete(dataObject.name);
        appDataStore.add(dataObject);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ success: false, error });
    }
});

// eslint-disable-next-line no-async-promise-executor
const getByName = (name) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('appData', 'readonly');
        const appDataStore = transaction.objectStore('appData');

        const data = appDataStore.get(name.toString());

        transaction.oncomplete = () => {
            db.close();
            if (data.result) {
                resolve({ success: true, data: data.result });
            }
            else {
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const deleteByName = (name) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('appData', 'readwrite');
        const appDataStore = transaction.objectStore('appData');

        appDataStore.delete(name.toString());

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const appData = {
    add,
    getByName,
    deleteByName
};

export default appData;
